export const START_LOADING = 'AUTH__START_LOADING';
export const SUCCESS_LOADING = 'AUTH__SUCCESS_LOADING';
export const ERROR_LOADING = 'AUTH__ERROR_LOADING';
export const START_LOGGING_OUT = 'AUTH__START_LOGGING_OUT';
export const SUCCESS_LOGGING_OUT = 'AUTH__SUCCESS_LOGGING_OUT';
export const ERROR_LOGGING_OUT = 'AUTH__ERROR_LOGGING_OUT';
